export default {
  'EMAILTEMPLATE' (state) {
    return state.emailtemplate
  },
  'EMAILTEMPLATES' (state) {
    return state.emailtemplates
  }
}
